<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="480px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item prop="name" label="策略名称">
                        <el-col :span="9">
                            <el-input v-model="form.name" maxlength="80" style="width:195px"></el-input>
                        </el-col>
                    </el-form-item>
                     
                    <el-form-item prop="gateUser" label="选择人员绑定">
                        <el-button @click="findUser()">{{form.gateUserLabel}}</el-button>
                    </el-form-item>

                    <el-form-item   prop="" label="开启时间段">
                        <el-button type="primary"  size="mini" icon="el-icon-plus" @click="setAddTime()">新增</el-button>
                        <el-table
                            :data="times"
                            height="150"
                            border
                            style="width: 330px;">
                            <el-table-column prop="startTime" label="开始时间" width="110"> </el-table-column>
                            <el-table-column prop="endTime" label="结束时间" width="110"> </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button style="color: red" @click.native.prevent="delTime(scope.$index)"
                                        type="text"
                                        size="small">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>

                    <el-form-item prop="timeType" label="时间类型">
                        <el-select v-model="form.timeType" clearable placeholder="请选择">
                            <el-option
                                v-for="item in timeTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="setOpenCycle" label="开启周期" v-if="form.timeType == 2">
                        <el-select v-model="form.setOpenCycle" clearable multiple placeholder="请选择">
                            <el-option
                                v-for="item in setOpenCycles"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="" label="临时开启日期" v-if="form.timeType == 3">
                        <el-button type="primary"  size="mini" icon="el-icon-plus" @click="setAddDate()">新增</el-button>
                        <el-table
                            :data="dates"
                            height="150"
                            border
                            style="width: 330px;">
                            <el-table-column prop="startDate" label="开始日期" width="110"> </el-table-column>
                            <el-table-column prop="endDate" label="结束日期" width="110"> </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button style="color: red" @click.native.prevent="delDate(scope.$index)"
                                        type="text"
                                        size="small">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>


            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
        <!-- 时间弹出框 -->
        <div v-if="addTimeVisible">
            <addTime ref="addTime"></addTime>
        </div>
        <!-- 日期弹出框 -->
        <div v-if="addDateVisible">
            <addDate ref="addDate"></addDate>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import addTime from './AddTime.vue';
    import addDate from './AddDate.vue';

    export default {
        data(){
            return{
                visible: false,
                isAuto:false,
                transferVisible:false,
                addTimeVisible:false,
                addDateVisible:false,
                props: { checkStrictly: true},
                form:{
                    id:"",
                    deptId:"",
                    name:"",
                    deviceNo:"",
                    timeType:"",
                    setOpenCycle:[],
                    gateUser:[],
                    gateUserLabel:"请选择"
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    timeType: [
                        { required: true, message: '请选择时间类型', trigger: 'blur' }
                    ]
                },
                classes:[],
                devices:[],
                times:[],
                dates:[],
                timeTypes:[{
                    value: 1,
                    label: '每日'
                }, {
                    value: 2,
                    label: '每周'
                }, {
                    value: 3,
                    label: '日期'
                }],
                setOpenCycles:[{
                    value: 'monday',
                    label: '星期一'
                }, {
                    value: 'tuesday',
                    label: '星期二'
                }, {
                    value: 'wednesday',
                    label: '星期三'
                }, {
                    value: 'thursday',
                    label: '星期四'
                }, {
                    value: 'friday',
                    label: '星期五'
                }, {
                    value: 'saturday',
                    label: '星期六'
                }, {
                    value: 'sunday',
                    label: '星期日'
                }]
            }
        },
        created:function () {
        },
        components: {
            userTransfer,addTime,addDate
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                //初始值
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.deviceNo=data.deviceNo;
                this.form.timeType=data.timeType;
                this.form.deptId=data.deptId;
                //开启周期
                if(this.$util.isNotEmpty(data.setOpenCycle)){
                    this.form.setOpenCycle=data.setOpenCycle.split(",");
                }
                //开启时间
                this.getGateTime(data.id);
                //开启日期
                this.getGateDate(data.id);
                //绑定人员
                this.getGateUser(data.id);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 开启时间
            getGateTime(gateId){
                let url  = this.listSetGateTimeUrl;
                let data = {setGateId:gateId};
                this.apiPost(url,data).then((res) => {
                    // console.log("时间列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.times = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 开启日期
            getGateDate(gateId){
                let url  = this.listSetGateDateUrl;
                let data = {setGateId:gateId};
                this.apiPost(url,data).then((res) => {
                    // console.log("日期列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.dates = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 绑定人员
            getGateUser(gateId){
                let url  = this.listsetGateUserUrl;
                let data = {setGateId:gateId};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      let gateUserArr=new Array();
                      let data=res.data.list;
                      for(var i=0;i<data.length;i++){
                          gateUserArr.push(data[i].userId);
                      }
                      this.form.gateUser = gateUserArr; 
                      this.form.gateUserLabel=res.data.list.length+"人";
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 时间段操作
            setAddTime(){
                this.addTimeVisible=true;
                this.$nextTick(() => {
                    this.$refs['addTime'].init();
                })
            },
            addTime(data){
                this.times.push(data);
            },
            delTime(index){
                this.times.splice(index, 1);
            },
            // 日期段操作
            setAddDate(){
                this.addDateVisible=true;
                this.$nextTick(() => {
                    this.$refs['addDate'].init();
                })
            },
            addDate(data){
                this.dates.push(data);
            },
            delDate(index){
                this.dates.splice(index, 1);
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.gateUser)){
                        this.$refs['userTransfer'].init("",this.form.gateUser,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init("",null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                if(keyArr.length == 0){
                    this.form.gateUser=keyArr;
                    this.form.gateUserLabel="请选择";
                }else{
                  this.form.gateUser=keyArr;
                  this.form.gateUserLabel=keyArr.length+"人";
                }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){

                        // 开启时间不可为空
                        if(this.times.length == 0){
                            this.$commonFn.showTip('开启时间不可为空',3);
                            return;
                        }

                        // 切换时间类型，保留对应值，其他去除
                        if(this.form.timeType == 1){
                            this.form.gateDate=[];
                            this.form.setOpenCycle=[];
                        }else if(this.form.timeType ==2){
                            this.dates=[];
                        }else if(this.form.timeType ==3){
                            this.form.setOpenCycle=[];
                        }

                        let url = this.setGateStrategyUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            name:this.form.name,
                            deviceNo:this.form.deviceNo,
                            timeType:this.form.timeType,
                            setOpenCycle:this.form.setOpenCycle.join(),
                            gateUser:this.form.gateUser.join(),
                            gateTime:JSON.stringify(this.times),
                            gateDate:JSON.stringify(this.dates)
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                                this.visible=false;
                                this.$parent.getData();
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/gate/Update.vue